var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "12", height: "20", viewBox: "0 0 12 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.16262 8.13099C9.36642 7.94466 9.68269 7.95882 9.86902 8.16262C10.0554 8.36642 10.0412 8.68269 9.83739 8.86902L6.33739 12.069C6.14637 12.2437 5.85364 12.2437 5.66262 12.069L2.16262 8.86902C1.95882 8.68269 1.94466 8.36642 2.13099 8.16262C2.31732 7.95882 2.63359 7.94466 2.83739 8.13099L6 11.0225L9.16262 8.13099Z", fill: "#303030" })
  );
});